import { Contact } from '../models/Contact'
import { Container } from '../../../common/container/Container'
import { IStatusService } from '../../../common/status/StatusService'
import { Observable } from 'rxjs'
import { Query } from '../../../common/api/Query'
import { IContactApi } from '../api/ContactApi'
import { STATUS_SERVICE_KEY } from '../../../container/app'

type Props = {
  apiKey: symbol
}

export interface IContactService {
  getByID(id: string): Observable<Contact | undefined>

  getFilteredItems(q: Query<Contact>): Observable<Contact[]>

  add(e: Contact): Observable<Contact | undefined>

  update(e: Contact): Observable<Contact | undefined>

  delete(e: Contact): Observable<boolean>
}

export class ContactService implements IContactService {
  protected readonly _apiKey: symbol
  protected _container!: Container
  protected _api!: IContactApi
  protected _statusService!: IStatusService

  constructor(p: Props) {
    this._apiKey = p.apiKey
  }

  init(c: Container) {
    this._container = c
    this._api = this._container.get<IContactApi>(this._apiKey)
    this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
  }

  add(e: Contact): Observable<Contact | undefined> {
    return this._api.add(e)
  }

  delete(e: Contact): Observable<boolean> {
    return this._api.delete(e)
  }

  getByID(id: string): Observable<Contact | undefined> {
    return this._api.getByID(id)
  }

  getFilteredItems(q: Query<Contact>): Observable<Contact[]> {
    return this._api.getFilteredItems(q).pipe()
  }

  update(e: Contact): Observable<Contact | undefined> {
    return this._api.update(e)
  }
}
